module.exports = __webpack_public_path__ + "img/2.ce4b39cf.jpg";